import { render, staticRenderFns } from "./QuestionLikertItem.vue?vue&type=template&id=98c8d49e&scoped=true&"
import script from "./QuestionLikertItem.vue?vue&type=script&lang=js&"
export * from "./QuestionLikertItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLikertItem.vue?vue&type=style&index=0&id=98c8d49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c8d49e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
